import './App.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { checkUser } from "./Components/Tools";
import axios from 'axios';
import qs from 'qs';

/* Les différents fichiers */
import Homepage from "./Homepage";
import Adminpage from "./Adminpage";
import Utilisateurs from "./Gestion/Utilisateurs";
import Application from "./Gestion/Application";
import Restitutions from "./Gestion/Restitutions";
import Organismes from "./Gestion/Organismes";
import Organismepage from "./Organismepage";
import Partenairepage from "./Partenairepage";
import ListeUtilisateursParCommune from "./ListeUtilisateursParCommune";
import Moncompte from "./Moncompte";
import SaisieRetro from "./SaisieRetro";
import SaisieProsp from "./SaisieProsp";
import FichesProjets from "./FichesProjets";
import FichesProjetsListing from "../src/FichesProjetsListing";
import FicheProjet from "./FicheProjet";
import OperationsListing from "./OperationsListing";
import SaisieFisc from "./SaisieFisc";
import Dette from "./Dette";
import Restitution from "./Restitution";
import NotFound from "./NotFound";
import Register from "./Register";
import Checktoken from "./Checktoken";
import Login from "./Login";
import Logout from "./Logout";
import MassiveMailing from "./MassiveMailing";
import Clients from "./Gestion/Clients";
import ModalitesPortage from "./Gestion/ModalitesPortage";
import AxesInterventions from "./Gestion/AxesInterventions";
import Territoires from "./Gestion/Territoires";
import TauxAnnuel from "./Gestion/TauxAnnuel";
import Operations from "./Operations";
import OperationPage from "./OperationPage";
import TableauDeBord from "./TableauDeBord";
import GraphTableauDeBord from "./BilanTableauBord/GraphTableauDeBord";
import Graphiques from "./Graphiques";
import GraphiquesEpfl from "./GraphiquesEpfl";
import VerifRetro from "./VerifRetro";
import CalculEmpruntsManuel from "./CalculEmpruntsManuel";
import CalculEmpruntsAuto from "./CalculEmpruntsAuto";
import BilanPDF from "./BilanRapportFinancier/BilanPDF";
import BilanPDFEpfl from "./BilanRapportFinancierEpfl/BilanPDF";
import BilanProjets from "./BilanProjets/BilanProjets";
import SyntheseProjets from "./SyntheseProjets/SyntheseProjets";
import SyntheseOperations from "./SyntheseOperations/SyntheseOperations";
import Hypothese from "./CommentaireHypothese";
import FacturationEpfl from "./FacturationEpfl";



const App = () =>
{
	const [user, setUser] = useState(null);
	
	function getDroits(id_user)
    {
        var params = {
            'getDroits': true,
            'id_user': id_user
        }
        return axios.post('https://app-slfinance.fr/api/droits.php', qs.stringify(params))
        .then((res) => {
            if (res.data['status'] === 1) {
                return res.data.droits;
            }
        })
        .catch((err) => {
            console.warn(err);
            return [];
        });
    }

	function getConfigBudgetByParams(id_budget)
	{
		return axios.get('https://app-slfinance.fr/api/config_budget.php?id_budget=' + id_budget)
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			console.warn(err);
			return [];
		})
	}
	
	
	function getUser()
	{
		const token = localStorage.getItem("session_token")
		checkUser(token)
		.then(async (result) => {
			if (result !== false) {
				await getDroits(result.id)
				.then(async (r) => {
					result.droits = r;
					await getConfigBudgetByParams(result.id_budget)
					.then(async (config_budget) => {
						var tmp = [];
						config_budget.map((item) => {
							tmp[item[2]] = item[3];
						})
						result.config_budget = tmp;
					})
					await setUser(result);
				})
			}
		})
	}

    return (
		<div style={{background: "linear-gradient(#EDEDED, #FFFFFF)", minHeight: window.innerHeight}}>
			<Router>
				<Switch>
					<Route path='/' exact><Homepage /></Route>

					{/* Les routes en connexion */}
					<Route path='/adminpage' exact><Adminpage user={user} getUser={getUser} /></Route>
					<Route path='/gestion/utilisateurs' exact><Utilisateurs user={user} getUser={getUser} /></Route>
					<Route path='/gestion/application' exact><Application user={user} getUser={getUser} /></Route>
					<Route path='/gestion/clients' exact><Clients user={user} getUser={getUser} /></Route>
					<Route path='/gestion/restitutions' exact><Restitutions user={user} getUser={getUser} /></Route>
					<Route path='/gestion/organismes' exact><Organismes user={user} getUser={getUser} /></Route>
					<Route path='/Gestion/ModalitesPortage' exact><ModalitesPortage user={user} getUser={getUser} /></Route>
					<Route path='/Gestion/AxesInterventions' exact><AxesInterventions user={user} getUser={getUser} /></Route>
					<Route path='/Gestion/Territoires' exact><Territoires user={user} getUser={getUser} /></Route>
					<Route path='/Gestion/TauxAnnuel' exact><TauxAnnuel user={user} getUser={getUser} /></Route>
					<Route path='/utilisateurs' exact><ListeUtilisateursParCommune user={user} getUser={getUser} /></Route>
					<Route path='/organismepage' exact><Organismepage user={user} getUser={getUser} /></Route>
					<Route path='/facturation/epfl' exact><FacturationEpfl user={user} getUser={getUser} /></Route>
					<Route path='/partenairepage' exact><Partenairepage user={user} getUser={getUser} /></Route>
					<Route path='/moncompte' exact><Moncompte user={user} getUser={getUser} /></Route>
					<Route path='/massivemailing' exact><MassiveMailing user={user} getUser={getUser} /></Route>

					{/* Fonctionnement */}
					<Route path='/saisie/retrospective/fct/recette' exact><SaisieRetro user={user} getUser={getUser} /></Route>
					<Route path='/saisie/retrospective/fct/depense' exact><SaisieRetro user={user} getUser={getUser} /></Route>

					<Route path='/saisie/prospective/fct/recette' exact><SaisieProsp user={user} getUser={getUser} /></Route>

					<Route path='/saisie/prospective/fct/depense' exact><SaisieProsp user={user} getUser={getUser} /></Route>

					{/* Investissemenet */}
					<Route path='/saisie/retrospective/inv/recette' exact><SaisieRetro user={user} getUser={getUser} /></Route>
					<Route path='/saisie/retrospective/inv/depense' exact><SaisieRetro user={user} getUser={getUser} /></Route>

					{/* Fiscalité */}
					<Route path='/saisie/retrospective/fiscalite' exact><SaisieFisc user={user} getUser={getUser} /></Route>

					<Route path='/saisie/prospective/fiscalite' exact><SaisieFisc user={user} getUser={getUser} /></Route>

					{/* Fiches projets */}
					<Route path='/fichesprojets' exact><FichesProjets user={user} getUser={getUser} /></Route>
					<Route path='/saisie/prospective/ficheprojet/:id' ><FicheProjet user={user} getUser={getUser} /></Route>
					<Route path='/fichesprojets/listing' exact><FichesProjetsListing user={user} getUser={getUser} /></Route>
					
					{/* Opérations EPFL */}
					<Route path='/operations' exact><Operations user={user} getUser={getUser} /></Route>
					<Route path='/operations/listing' exact><OperationsListing user={user} getUser={getUser} /></Route>
					<Route path='/operation/saisie/:id' exact><OperationPage user={user} getUser={getUser} /></Route>

					{/* Commentaires Hypothèses */}
					<Route path='/saisie/prospective/commentaire' exact><Hypothese user={user} getUser={getUser} /></Route>

					{/* Dette */}
					<Route path='/saisie/dette' exact><Dette user={user} getUser={getUser} /></Route>

					{/* Vérification Retro */}
					<Route path='/verification/retrospective' exact><VerifRetro user={user} getUser={getUser} /></Route>

					{/* Restitution */}
					<Route path='/restitution/retrospective/fct' exact><Restitution user={user} getUser={getUser} /></Route>
					<Route path='/restitution/retrospective/inv' exact><Restitution user={user} getUser={getUser} /></Route>
					<Route path='/restitution/retrospective/fiscalite' exact><Restitution user={user} getUser={getUser} /></Route>
					<Route path='/restitution/prospective/fct' exact><Restitution user={user} getUser={getUser} /></Route>
					<Route path='/restitution/prospective/inv' exact><Restitution user={user} getUser={getUser} /></Route>
					{/* <Route path='/restitution/prospective/fiscalite' exact><Restitution user={user} getUser={getUser} /></Route> */}

					{/* Tableau de Bord */}
					<Route path='/tableaudebord' exact><TableauDeBord user={user} getUser={getUser} /></Route>
					<Route path='/graphtableaudebord' exact><GraphTableauDeBord user={user} getUser={getUser} /></Route>

					{/* Calcul Emprunts Manuel */}
					<Route path='/emprunts/manuel' exact><CalculEmpruntsManuel user={user} getUser={getUser} /></Route>

					{/* Calcul Emprunts Automatique */}
					<Route path='/emprunts/auto' exact><CalculEmpruntsAuto user={user} getUser={getUser} /></Route>

					{/* Graphiques */}
					<Route path='/graphiques' exact><Graphiques user={user} getUser={getUser} /></Route>
					<Route path='/graphiques/epfl' exact><GraphiquesEpfl user={user} getUser={getUser} /></Route>
					
					{/* PDF */}
					<Route path='/rapport/financier' exact><BilanPDF user={user} getUser={getUser} /></Route>
					<Route path='/rapport/financier/epfl' exact><BilanPDFEpfl user={user} getUser={getUser} /></Route>
					<Route path='/rapport/financier/projets' exact><BilanProjets user={user} getUser={getUser} /></Route>
					<Route path='/rapport/synthese/projets' exact><SyntheseProjets user={user} getUser={getUser} /></Route>
					<Route path='/rapport/synthese/operations' exact><SyntheseOperations user={user} getUser={getUser} /></Route>

					{/* Les routes hors connexion */}
					<Route path='/register' exact><Register /></Route>
					<Route path='/checktoken' exact><Checktoken /></Route>
					<Route path='/login' exact><Login /></Route>
					<Route path='/logout' exact><Logout /></Route>

					<Route><NotFound/></Route>
				</Switch>
			</Router>
		</div>
    );
}

export default App;